export default __webpack_public_path__ + "static/media/shipping.a2e22b5f.png";